import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgIsr = function SvgIsr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.969 2.667h24.057c1.21 1.04 1.985 2.306 2.463 3.333H1.529c.47-1.022 1.238-2.288 2.44-3.333ZM1.529 26H30.47c-.471 1.022-1.239 2.288-2.44 3.333H3.969C2.768 28.288 2 27.023 1.53 26Zm20.911-6.125L16 8.72 9.56 19.875h12.88Zm-1.732-1h-9.416L16 10.72l4.708 8.155Z",
    fill: "#2C97DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 23.208 6.44-11.155H9.56L16 23.208Zm0-2-4.708-8.155h9.416L16 21.208Z",
    fill: "#2C97DE"
  }));
};

export default SvgIsr;